module.exports = __webpack_public_path__ + "static/media/block-audio.8db92c02.svg";